<script>
    import { t, locale, locales } from "../../../scripts/i18n";
</script>

<div class="panel-inner-wrap">
    <div class="checkbox-w-label-wrap border-bottom p-20px">
        <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
            <label class="checkbox-container">
                <input type="checkbox" checked>
                <span class="checkmark checkmark-small"></span>
            </label>
        </div>
        <div class="label-text-wrap text-left">{$t('Bots and mass followers')}</div>
    </div>

    <div class="checkbox-w-label-wrap border-bottom p-20px">
        <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
            <label class="checkbox-container">
                <input type="checkbox" checked>
                <span class="checkmark checkmark-small"></span>
            </label>
        </div>
        <div class="label-text-wrap text-left">{$t('Commercial accounts')}</div>
    </div>

    <div class="checkbox-w-label-wrap p-20px">
        <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
            <label class="checkbox-container">
                <input type="checkbox" checked>
                <span class="checkmark checkmark-small"></span>
            </label>
        </div>
        <div class="label-text-wrap text-left">{$t('Foreign accounts')}</div>
    </div>

    <div class="foreigners-params-wrap">
        <p class="text-left">{$t('Selected groups of foreigners will be blocked:')}</p>
        <div class="checkbox-w-label-wrap mb-10px">
            <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
                <label class="checkbox-container">
                    <input type="checkbox" checked>
                    <span class="checkmark checkmark-small"></span>
                </label>
            </div>
            <div class="label-text-wrap text-left">{$t('Arab (Egypt, Sudan, Libya, etc.)')}</div>
        </div>
        <div class="checkbox-w-label-wrap mb-10px">
            <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
                <label class="checkbox-container">
                    <input type="checkbox" checked>
                    <span class="checkmark checkmark-small"></span>
                </label>
            </div>
            <div class="label-text-wrap text-left">{$t('Asian (China, Japan, Korea, etc.)')}</div>
        </div>
        <div class="checkbox-w-label-wrap mb-10px">
            <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
                <label class="checkbox-container">
                    <input type="checkbox">
                    <span class="checkmark checkmark-small"></span>
                </label>
            </div>
            <div class="label-text-wrap text-left">{$t('Cyrillic (Russia, Ukraine, Belarus, etc.)')}</div>
        </div>
        <div class="checkbox-w-label-wrap mb-10px">
            <div class="custom-checkbox-wrap custom-checkbox-wrap-small mr-10px">
                <label class="checkbox-container">
                    <input type="checkbox">
                    <span class="checkmark checkmark-small"></span>
                </label>
            </div>
            <div class="label-text-wrap text-left">{$t('English (USA, England, Canada, etc.)')}</div>
        </div>
    </div>
</div>


<style>
    .p-20px {
        padding: 20px;
    }
    .border-bottom {
        border-bottom: 1px solid grey;
    }
    .checkbox-w-label-wrap .label-text-wrap {
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #000;
    }
    .foreigners-params-wrap {
        padding-left: 27px;

        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        margin-top: 5px;
    }
    .foreigners-params-wrap .checkbox-w-label-wrap .label-text-wrap {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 16px;
        margin-top: 5px;
    }
    .panel-inner-wrap {
        text-align: left;
        padding: 10px 25px;
        border: 1px solid #8001bd;
        box-sizing: border-box;
        border-radius: 10px;
    }
</style>